export default __webpack_public_path__ + "static/media/fountain2.ee6346bb.jpg";